import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface WorkingModeContextType {
  isWorkMode: boolean;
  toggleWorkMode: () => void;
  setWorkMode: (isActive: boolean) => void;
}

const WorkingModeContext = createContext<WorkingModeContextType | undefined>(undefined);

const WORK_MODE_STORAGE_KEY = 'workwallet_work_mode';

export const WorkingModeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isWorkMode, setIsWorkMode] = useState<boolean>(() => {
    try {
      const stored = localStorage.getItem(WORK_MODE_STORAGE_KEY);
      return stored ? JSON.parse(stored) : false;
    } catch {
      return false;
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem(WORK_MODE_STORAGE_KEY, JSON.stringify(isWorkMode));
    } catch (error) {
      console.error('Error saving work mode to localStorage:', error);
    }
  }, [isWorkMode]);

  const toggleWorkMode = () => {
    setIsWorkMode(prev => !prev);
  };

  const setWorkMode = (isActive: boolean) => {
    setIsWorkMode(isActive);
  };

  return (
    <WorkingModeContext.Provider value={{ isWorkMode, toggleWorkMode, setWorkMode }}>
      {children}
    </WorkingModeContext.Provider>
  );
};

export const useWorkingMode = (): WorkingModeContextType => {
  const context = useContext(WorkingModeContext);
  if (context === undefined) {
    throw new Error('useWorkingMode must be used within a WorkingModeProvider');
  }
  return context;
};

